'use strict';

/**
 * @deprecated
 */
function salaryQuestionnaireAnswerService($http, $interpolate) {
  // var listURL = '/api/salary/answer/';
  var detailTokenURL = $interpolate('/api/salary/answer/{{token}}/');

  return {
    retrieve: retrieve,
    patch: patch
  };

  function retrieve(token, step) {
    return $http.get(detailTokenURL({ token: token }), { params: { step: step } });
  }

  function patch(token, changes) {
    return $http({ url: detailTokenURL({ token: token }), method: 'PATCH', data: changes });
  }
}

module.exports = salaryQuestionnaireAnswerService;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/service/salary-questionnaire-answer/index.js
 ** module id = 205
 ** module chunks = 0
 **/